import styled from "styled-components";


export const Header = styled.header`
width: 100vw;
height: 20vh;
align-items: center;
img{
    width: 600px;
    height: 200px;
}
text-align: center;
`
